export default __webpack_public_path__ + "static/comparatif-geovelo-6a7eeeb9abdc8d1fd921a8e6037af466.png";